import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import NumbersIcon from "@mui/icons-material/Numbers";
import PauseIcon from "@mui/icons-material/Pause";
import SettingsIcon from "@mui/icons-material/Settings";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

/** Static play toolbar shown above the board on store screenshots. */
export default function ScreenshotPlayToolbar({ onDark = false }) {
    const iconColor = onDark ? "#86efac" : "#3BA666";
    const textColor = onDark ? "#f8fafc" : "#0f172a";
    const iconSx = { fontSize: 22, color: iconColor };
    return (
        <Box
            sx={{
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                minHeight: 44,
                px: 0.5,
                boxSizing: "border-box",
            }}
        >
            <ArrowBackIcon aria-hidden sx={{ fontSize: 22, color: onDark ? "#e2e8f0" : "#334155" }} />
            <Typography
                component="span"
                sx={{ fontWeight: 700, fontSize: "0.95rem", fontVariantNumeric: "tabular-nums", color: textColor }}
            >
                1:24
            </Typography>
            <PauseIcon aria-hidden sx={iconSx} />
            <Box
                sx={{
                    px: 1,
                    height: 28,
                    display: "inline-flex",
                    alignItems: "center",
                    borderRadius: 99,
                    border: onDark ? "1px solid rgba(226,232,240,0.45)" : "1px solid #cbd5e1",
                    color: textColor,
                    fontSize: "0.8rem",
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                }}
            >
                Moves 6
            </Box>
            <Box sx={{ flex: 1 }} />
            <LightbulbOutlinedIcon aria-hidden sx={iconSx} />
            <NumbersIcon aria-hidden sx={iconSx} />
            <SettingsIcon aria-hidden sx={iconSx} />
        </Box>
    );
}

ScreenshotPlayToolbar.propTypes = {
    onDark: PropTypes.bool,
};
